import request from "_private/utils/request";

/**
 * @description 获取路由
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchGetUserMenuRoutes(data) {
    return request({
        url: "/base/userMenu/getUserMenuRoutes",
        method: "post",
        data
    });
}

/**
 * @description 获取菜单
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchGetUserMenu(data) {
    return request({
        url: "/base/userMenu/getUserMenu",
        method: "post",
        data
    });
}
